// frontend/src/pages/AcceptedResponsesViewer.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_URL from '../api/baseURL';


// The car the parts are for, however we can get it. `car` is populated while
// the vehicle exists; the RFQ's snapshots are what it remembers once the
// vehicle has been renamed or deleted, and an accepted quote outlives the
// vehicle record.
const vehicleOf = (res) => {
  const car = res?.rfq?.car;
  const snap = res?.rfq?.vehicleSnapshot;
  return {
    label: [car?.brand || snap?.make, car?.model || snap?.model, car?.year || snap?.year]
      .filter(Boolean).join(' '),
    plate: car?.plateNumber || '',
    // The reference the supplier actually orders against: it decides which
    // variant of a part fits, and this is the page they do the ordering from.
    vin: String(car?.vin || res?.rfq?.vinSnapshot || '').trim().toUpperCase(),
  };
};

const AcceptedResponsesViewer = ({ token }) => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/spare-parts/responses/accepted`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      setResponses(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [token]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">✅ Accepted Quotation Responses</h2>

      {loading ? <p>Loading...</p> : responses.length === 0 ? (
        <p>No accepted responses.</p>
      ) : (
        <div className="space-y-6">
          {responses.map((res, i) => {
            const veh = vehicleOf(res);
            return (
            <div key={i} className="border p-4 rounded bg-[#17140F] shadow">
              {/* The vehicle replaces a "Client" line that could only ever
                  print "Unknown": getAcceptedResponses projects the RFQ down
                  to car/snapshots/status/createdAt, so owner was never in the
                  payload to read. */}
              <p><strong>Véhicule :</strong> {veh.label || '—'}
                {veh.plate && <span className="text-[#C9C3B6]"> · {veh.plate}</span>}
              </p>
              {veh.vin && (
                <p className="tracking-[.06em] break-all">
                  <strong>VIN :</strong> {veh.vin}
                </p>
              )}
              <p><strong>Status:</strong> {res.status}</p>
              <p><strong>Delivery ETA:</strong> {res.deliveryETA}</p>
              <p><strong>Note:</strong> {res.notes}</p>
              <div className="mt-2">
                <h4 className="font-semibold">Parts Offered:</h4>
                <ul className="list-disc ml-6">
                  {(res.items || []).map((p, j) => (
                    <li key={j}>
                      {p.description || p.name || 'Item'} — Qty: {p.quantity}, Price: {p.supplierPrice}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AcceptedResponsesViewer;
